export default "__VITE_ASSET__JUZ2kld$__"